import React from "react";

export const ModalRecipientEmail = ({ recipientEmail }) => {
	
	return (
		<div className="modal fade px-0" id="ModalRecipientEmail" aria-labelledby="ModalRecipientEmailLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<header className="modal-header">
						<div className="alert bg-alert-info rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Recipient email</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 text-info text-uppercase mb-0 font-weight-bolder ls-n1 lh-1 mx-auto" id="ModalRecipientEmailLabel">
									Adresse e-mail de réception
								</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</header>
					<div className="modal-body scroll-default py-0">
						<p className="h5 lh-copy mb-sm">Les documents envoyés à votre adresse e-mail de réception seront automatiquement importés dans votre bibliothèque.</p>
						<section className="card card-body bg-light rounded">
							<div className="row gx-2 gy-1">
								<div className="col-auto">
									<div className="h6 font-weight-bolder mt-auto text-capitalize mb-1">Email de réception</div>
									<p className="h5 mb-auto">{recipientEmail}</p>
								</div>
							</div>
						</section>
					</div>
					<div className="modal-footer">
						<button type="button" className="btn btn-light" data-dismiss="modal">
							Fermer
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
